// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Index__pc_only___2p9ap","sp_only":"Index__sp_only___2cReA","summary_container":"Index__summary_container___pG5KB"};